import { addDays, formatDistanceToNow, parseJSON } from "date-fns";

import { Metastore } from "@prequel/react";

const MAGIC_LINK_TTL_DAYS = 7;

export const getTimeRemaining = (dateString: string) => {
  const date = parseJSON(dateString);
  const expirationDate = addDays(date, MAGIC_LINK_TTL_DAYS);
  return formatDistanceToNow(expirationDate);
};

export interface MagicLink {
  name: string;
  recipient_id: string;
  host?: string;
  bucket_name?: string;
  vendor: string;
  bucket_vendor?: string;
  bucket_access_id?: string;
  bucket_host?: string;
  set_destination_enabled: boolean;
  metastore?: Metastore;
  catalog?: string;
  table_bucket_arn?: string;
  redirect_url?: string;
}

export interface ExistingMagicLink extends MagicLink {
  readonly id: string;
  readonly created_at: string;
  readonly link: string;
  readonly has_been_used: boolean;
  readonly id_in_provider_system: string;
}
